// Content layer multilingua.
// - `mock.js` resta la fonte IT (invariata).
// - `translations/en.js` e `translations/de.js` contengono SOLO gli override testuali.
// - La lingua attiva viene letta dall'URL; il merge profondo applica gli override
//   con fallback automatico all'italiano (una stringa mancante resta in IT).
// I componenti importano i dati da qui invece che da `./mock`.
import * as base from "./mock";
import { overrides as enOverrides } from "./translations/en";
import { overrides as deOverrides } from "./translations/de";
import { overrides as frOverrides } from "./translations/fr";
import { getActiveLang } from "../lib/activeLang";

function isPlainObject(x) {
  return x !== null && typeof x === "object" && !Array.isArray(x);
}

function deepMerge(b, o) {
  if (o === undefined || o === null) return b;
  if (Array.isArray(b) && Array.isArray(o)) {
    return b.map((item, i) => (i < o.length ? deepMerge(item, o[i]) : item));
  }
  if (isPlainObject(b) && isPlainObject(o)) {
    const out = { ...b };
    for (const k of Object.keys(o)) out[k] = deepMerge(b[k], o[k]);
    return out;
  }
  return o;
}

const OVERRIDES = { it: {}, en: enOverrides, de: deOverrides, fr: frOverrides };

export const LANG = getActiveLang();
const ov = OVERRIDES[LANG] || {};
const m = (name) => deepMerge(base[name], ov[name]);

export const brand = m("brand");
// Nav: nelle lingue estere (EN/DE/FR) rimuoviamo "Chiavi in mano" e promuoviamo
// il suo sottomenu "Installatori" a voce top-level (così non sparisce).
export const nav = (() => {
  const merged = m("nav");
  if (LANG === "it") return merged;
  const out = [];
  for (const item of merged) {
    if (item.href === "/chiavi-in-mano") {
      (item.children || []).forEach((c) => out.push({ label: c.label, href: c.href }));
      continue;
    }
    out.push(item);
  }
  return out;
})();
export const ecosystem = m("ecosystem");
export const heroStats = m("heroStats");
export const solarLab = m("solarLab");
export const certificazioni = m("certificazioni");
export const timeline = m("timeline");
export const gruppo = m("gruppo");
export const factory = m("factory");
export const technology = m("technology");
export const products = m("products");
export const productCategories = m("productCategories");
export const turnkey = m("turnkey");
export const partner = m("partner");
export const scenari = m("scenari");
export const research = m("research");
export const news = m("news");
export const newsCategories = m("newsCategories");
export const manifesto = m("manifesto");
export const footer = m("footer");
export const chiavi = m("chiavi");
export const prisma = m("prisma");
export const xcore = m("xcore");
export const projects = m("projects");
export const installers = m("installers");
export const techDetails = m("techDetails");
export const techModal = m("techModal");
export const productCatalog = m("productCatalog");
export const arcInfo = m("arcInfo");
export const topconInfo = m("topconInfo");
export const percInfo = m("percInfo");
export const solrifInfo = m("solrifInfo");
export const moduleDescriptions = m("moduleDescriptions");
export const panelDatasheet = m("panelDatasheet");
export const xcoreHalfCellDatasheet = m("xcoreHalfCellDatasheet");
export const xcoreModuleMeta = m("xcoreModuleMeta");
export const moduleDatasheets = m("moduleDatasheets");
export const productArchive = m("productArchive");
export const legalPages = m("legalPages");
export const inverterDatasheets = m("inverterDatasheets");
export const faqTecnologia = m("faqTecnologia");
